export default __webpack_public_path__ + "static/media/fractionAddition.d9e26c3f.svg";